/** @jsx jsx */
import React, { useState, useEffect, useRef } from 'react';
import { jsx, Box, Heading, Grid, Button, Text } from 'theme-ui';
import { ethers } from 'ethers';
import BurnerProvider from 'burner-provider';
import Web3Modal from 'web3modal';
import { Balance, Address } from '.';
import { usePoller } from '../hooks';
import WalletConnectProvider from '@walletconnect/web3-provider';

const INFURA_ID = '0f81cfb01c1c40afb8ac9e2698ca98a9'; // MY INFURA_ID, SWAP IN YOURS!

const web3Modal = new Web3Modal({
	//network: "mainnet", // optional
	cacheProvider: true, // optional
	providerOptions: {
		walletconnect: {
			package: WalletConnectProvider, // required
			options: {
				infuraId: INFURA_ID
			}
		}
	}
});

export default function Account(props) {
	const createBurnerIfNoAddress = () => {
		if (!props.injectedProvider && props.localProvider) {
			if (props.localProvider.connection && props.localProvider.connection.url) {
				props.setInjectedProvider(
					new ethers.providers.Web3Provider(new BurnerProvider(props.localProvider.connection.url))
				);
			} else if (props.localProvider._network && props.localProvider._network.name) {
				props.setInjectedProvider(
					new ethers.providers.Web3Provider(
						new BurnerProvider(
							'https://' + props.localProvider._network.name + '.infura.io/v3/' + INFURA_ID
						)
					)
				);
			} else {
				props.setInjectedProvider(
					new ethers.providers.Web3Provider(new BurnerProvider('https://mainnet.infura.io/v3/' + INFURA_ID))
				);
			}
		} else {
			pollInjectedProvider();
		}
	};
	useEffect(createBurnerIfNoAddress, [ props.injectedProvider ]);

	const pollInjectedProvider = async () => {
		if (props.injectedProvider) {
			let accounts = await props.injectedProvider.listAccounts();
			if (accounts && accounts[0] && accounts[0] != props.account) {
				//console.log("ADDRESS: ",accounts[0])
				if (typeof props.setAddress == 'function') props.setAddress(accounts[0]);
			}
		}
	};
	usePoller(() => {
		pollInjectedProvider();
	}, props.pollTime ? props.pollTime : 1999);

	const loadWeb3Modal = async () => {
		const provider = await web3Modal.connect();
		//console.log("GOT CACHED PROVIDER FROM WEB3 MODAL",provider)
		props.setInjectedProvider(new ethers.providers.Web3Provider(provider));
		pollInjectedProvider();
	};

	const logoutOfWeb3Modal = async () => {
		const clear = await web3Modal.clearCachedProvider();
		//console.log("Cleared cache provider!?!",clear)
		setTimeout(() => {
			window.location.reload();
		}, 1);
	};

	let modalButtons = [];
	if (web3Modal.cachedProvider) {
		modalButtons.push(
			<Button key="logoutbutton" className="tsf" sx={{ py: 'xxxs', px: 'xs' }} onClick={logoutOfWeb3Modal}>
				logout
			</Button>
		);
	} else {
		modalButtons.push(
			<Button key="loginbutton" className="tsf" sx={{ py: 'xxs', px: 'xs' }} onClick={loadWeb3Modal}>
				Connect Wallet
			</Button>
		);
	}

	React.useEffect(async () => {
		if (web3Modal.cachedProvider) {
			loadWeb3Modal();
		}
	}, []);

	return (
		<div sx={{ py: 'xs', px: 'xxs', backgroundColor: '#111', borderRadius: 'm', mb: 'm' }}>
			{props.address ? <Address value={props.address} ensProvider={props.mainnetProvider} /> : 'Connecting...'}
			{props.address ? <Balance address={props.address} provider={props.injectedProvider} dollarMultiplier={props.price}/> : "connect"}
			{modalButtons}
		</div>
	);
}
